export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('../partials-html/tags-section.html')
    };
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/partials-js/tagsSection.js